module.exports = __webpack_public_path__ + "img/approvals.79908aed.svg";